// frontend/src/pages/VerifyEmailPage.jsx
// Email 驗證頁面

import { useParams, Link } from 'react-router-dom';
import { Container, Box, Typography, Paper } from '@mui/material';
import VerifyEmail from '../components/Auth/VerifyEmail';

const VerifyEmailPage = () => {
  const { token } = useParams();

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        py: 4,
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={8}
          sx={{
            p: 4,
            borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.95)',
          }}
        >
          {/* Logo 區域 */}
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 'bold',
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              Email 驗證
            </Typography>
          </Box>

          {/* 驗證組件 */}
          <VerifyEmail token={token} />

          {/* 返回連結 */}
          <Box sx={{ mt: 4, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">
              需要幫助？{' '}
              <Link
                to="/login"
                style={{
                  color: '#667eea',
                  textDecoration: 'none',
                }}
              >
                聯繫我們
              </Link>
            </Typography>
          </Box>
        </Paper>

        {/* 版權資訊 */}
        <Typography
          variant="body2"
          sx={{
            mt: 3,
            textAlign: 'center',
            color: 'rgba(255, 255, 255, 0.7)',
          }}
        >
          &copy; {new Date().getFullYear()} 佛法搜尋資料庫
        </Typography>
      </Container>
    </Box>
  );
};

export default VerifyEmailPage;
